import { useId } from "react";

interface SliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
  format: (value: number) => string;
  hint?: string;
}

export function Slider({ label, value, min, max, step, onChange, format, hint }: SliderProps) {
  const id = useId();
  const fill = ((value - min) / (max - min)) * 100;
  return (
    <div className="field">
      <div className="slider-head">
        <label className="field-label" htmlFor={id}>
          {label}
        </label>
        <span className="mono slider-value">{format(value)}</span>
      </div>
      <input
        id={id}
        className="slider"
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        style={{ "--fill": `${fill}%` }}
        onChange={(event) => { onChange(Number(event.target.value)); }}
      />
      <div className="slider-scale mono">
        <span>{format(min)}</span>
        <span>{format(max)}</span>
      </div>
      {hint === undefined ? null : <div className="field-hint">{hint}</div>}
    </div>
  );
}
